import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import ManagerShell from './app/ManagerShell.js';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <ManagerShell />
  </React.StrictMode>
);
